import { InjectionToken } from "@angular/core";
import { PageLengthChanger } from "./paging/pageLength/PageLengthChanger";

export const PAGE_LENGTH_CHANGER = new InjectionToken<PageLengthChanger>('PAGE_LENGTH_CHANGER');
